import { Sites } from '@ps/platform-message-framework/common/Sites';
import type { TranslationTag } from '@ps/web-core-intl';
import { Toggle, Translation } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-validators';
import React from 'react';
import { useSelector } from 'react-redux';

import { Error } from '@swf/account';
import { select } from '@swf/core/store';

import useDisableField from '../../../../../../hooks/useDisableField';
import InfoPrompt from '../../../../../InfoPrompt/InfoPrompt';

import {
  TXTCLI_As_per_US_regulationsX_we_have_ELL,
  TXTCLI_Female,
  TXTCLI_Gender,
  TXTCLI_Male,
  TXTWCL_As_per_French_regulationsX_we__ELL,
  TXTWCL_As_per_Italian_regulationsX_we_ELL,
  TXTWCL_As_per_Spanish_regulationsX_we_ELL,
  TXTWCL_It_needs_to_match_the_gender_o_ELL,
  TXTWCL_Please_select_your_gender,
  TXTWCL_Prefer_not_to_say_1,
  TXTWCL_Why_do_we_need_itX
} from './GenderToggles.messages.json';
import styles from './GenderToggles.scss';

const regulatorMessage: Partial<Record<Sites, TranslationTag>> = {
  [Sites.FRA]: TXTWCL_As_per_French_regulationsX_we__ELL,
  [Sites.ITA]: TXTWCL_As_per_Italian_regulationsX_we_ELL,
  [Sites.SPA]: TXTWCL_As_per_Spanish_regulationsX_we_ELL,
  [Sites.USMI]: TXTCLI_As_per_US_regulationsX_we_have_ELL,
  [Sites.US_NJ]: TXTCLI_As_per_US_regulationsX_we_have_ELL,
  [Sites.US_PA]: TXTCLI_As_per_US_regulationsX_we_have_ELL
} as const;

const fieldName = 'gender';

const GenderToggles: React.FC = () => {
  const siteId = useSelector(select.cms.getSiteId);
  const disableField = useDisableField();
  const isPor = siteId === Sites.POR;

  const regulatorText = regulatorMessage[siteId];

  return (
    <>
      <div className={styles.tooltipWrapper}>
        <span className={styles.genderMargin}>
          <Translation {...TXTCLI_Gender} />
        </span>
        {!isPor && (
          <InfoPrompt title={{ translation: TXTWCL_Why_do_we_need_itX }}>
            <p className={styles.infoText}>
              {regulatorText ? (
                <>
                  <Translation {...regulatorText} />{' '}
                </>
              ) : null}
              <Translation {...TXTWCL_It_needs_to_match_the_gender_o_ELL} />
            </p>
          </InfoPrompt>
        )}
      </div>
      <Toggle
        id="male"
        name={fieldName}
        label={TXTCLI_Male}
        type="radio"
        value="M"
        disabled={disableField(fieldName)}
      />
      <Toggle
        id="female"
        name={fieldName}
        label={TXTCLI_Female}
        type="radio"
        value="F"
        disabled={disableField(fieldName)}
        validators={[required(TXTWCL_Please_select_your_gender)]}
      />
      {isPor && (
        <Toggle
          id="prefer-not-to-say"
          name={fieldName}
          label={TXTWCL_Prefer_not_to_say_1}
          type="radio"
          value="U"
          disabled={disableField(fieldName)}
        />
      )}
      <Error name={fieldName} className={styles.errorMessage} />
    </>
  );
};

export default GenderToggles;
